import { CHARACTER_WHITESPACE } from '../../../../../constants/common'
import {
  getCalendarCapWarningText,
  getCalendarOwnDayLoad,
} from '../../../Calendar.utils'

function getCalendarViewUserDay({ date, load }) {
  return load.days.find(day => day.date === date)
}

function getIsCalendarViewColleagueDayFull({ date, load, userId }) {
  return (
    load.user_id !== userId &&
    Boolean(getCalendarViewUserDay({ date, load })?.is_full)
  )
}

function toCalendarViewCapColleague({ date, limit, load }) {
  return {
    date,
    limit,
    used: getCalendarViewUserDay({ date, load }).follow_up_count,
    user: load.name,
    userId: load.user_id,
  }
}

export function getCalendarViewFollowUpCap({ data, date, user }) {
  const dayLoad = getCalendarOwnDayLoad({ data, date, user })

  return dayLoad?.is_full
    ? {
        colleagues: data.per_user
          .filter(load =>
            getIsCalendarViewColleagueDayFull({ date, load, userId: user.id })
          )
          .map(load =>
            toCalendarViewCapColleague({ date, limit: data.limit, load })
          ),
        dayLoad,
      }
    : null
}

export function getCalendarViewFollowUpUncheckedMoveText({
  dayLoad,
  locale,
  t,
}) {
  return dayLoad.is_full
    ? [
        t('Calendar.LoadCheckFailedKey'),
        getCalendarCapWarningText({ dayLoad, locale, t }),
      ].join(CHARACTER_WHITESPACE)
    : t('Calendar.LoadCheckFailedKey')
}
